import { useEffect } from 'react'
import { getUser } from 'api/getUser'
import { useAuth } from './AuthProvider'
import { useAppDispatch } from 'app/hooks'
import { setUserData, setUserLoading } from '@slices/auth'
import { useNavigate } from 'react-router-dom'
import { getUserId, persistUserId } from 'lib/auth/tokenStorage'

export const UserProvider = ({ children }) => {
  const { isAuthenticated, loading: authLoading, clearTokens } = useAuth()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  useEffect(() => {
    const fetchUserData = async () => {
      if (!isAuthenticated || authLoading) {
        return
      }

      if (!getUserId()) {
        clearTokens()
        navigate('/login', { replace: true })
        return
      }

      try {
        dispatch(setUserLoading(true))
        const data = await getUser()
        if (data) {
          dispatch(setUserData(data))
          persistUserId(data.current_user?.id || data.user?.id)
        }
      } catch (error) {
        console.error('Error fetching user data:', error)
        clearTokens()
        navigate('/login', { replace: true })
      } finally {
        dispatch(setUserLoading(false))
      }
    }

    fetchUserData()
  }, [isAuthenticated, authLoading, dispatch, clearTokens, navigate])

  return <>{children}</>
}
